// The IdeaCrunch mark: four chevron arrows compressing an amber core.
// Hand-built SVG faithful to the chosen generated logo - crisp at any size,
// transparent background, arrows follow the theme accent automatically
// (blue #2a78d6 in light, #3987e5 in dark via var(--accent)); the amber core
// is the gate color in both themes.

const ARROW = "M 8,44 L 26,44 L 26,37 L 40,50 L 26,63 L 26,56 L 8,56 Z";

export function Logo({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label="IdeaCrunch"
    >
      <g fill="var(--accent, #2a78d6)" transform="rotate(45 50 50)">
        <path d={ARROW} />
        <path d={ARROW} transform="rotate(90 50 50)" />
        <path d={ARROW} transform="rotate(180 50 50)" />
        <path d={ARROW} transform="rotate(270 50 50)" />
      </g>
      <circle cx="50" cy="50" r="9.5" fill="#fab219" />
    </svg>
  );
}
